import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared/shared.module';
import { AccountTypePage } from './pages/account-type/account-type.page';
import { LoginPage } from './pages/login/login.page';

@NgModule({
  declarations: [LoginPage, AccountTypePage],
  imports: [SharedModule],
})
export class AuthModule {}
